import schema from "lib/schema";
import { createElement } from "react";

export default function Components() {
  const setupItem = (category, item, e) => {
    if (category.setup) category.setup(item);
    const data = {
      item,
      action: "ADD",
    };
    e.dataTransfer.setData("text/plain", JSON.stringify(data));
    e.dataTransfer.dropEffect = "copy";
  };
  return (
    <div className="dr">
      <div className="dr-c">
        {schema.map((category, i) => {
          return (
            <div key={i} className="dr-b">
              <div className="dr-h">{category.name}</div>
              <div className="dr-e">
                {category.components.map((item, i) => {
                  return (
                    <div
                      key={i}
                      className="dr-i"
                      draggable
                      onDragStart={(e) => setupItem(category, item, e)}
                    >
                      <div className="dr-x">
                        {item.component ? (
                          createElement(item.component)
                        ) : (
                          <i className="fa fa-image"></i>
                        )}
                      </div>
                      <div>{item.name}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
